// extracted by mini-css-extract-plugin
export default {"content":"document-templates_content__qrJW6"};